// extracted by mini-css-extract-plugin
export default {"pageContainer":"Support_pageContainer__M4QQ9"};